import React from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {
  DEFAULT_COUNTRY_CODE,
  PHONE_ONLY_COUNTRIES,
  PHONE_PREFERRED_COUNTRIES,
} from "../../../assets/appConstants";
import phoneService from "../../../services/phoneService";
import PhoneInputService from "./phoneInputService";

class WCPhoneInput extends React.Component {
  constructor(props) {
    super(props);
    const countryCode = this.resolveInitialCountryIso(props.phone);
    this.state = {
      countryCode,
      geoReady: false,
    };
    this.userHasTyped = false;
    this.lastDialCode = this.resolveDialCode(props.phone, countryCode);
  }

  componentDidMount() {
    this.maybeDetectCountry();
  }

  componentDidUpdate(prevProps) {
    const prevDial = String(prevProps.phone?.countryCode || "").replace(/\D/g, "");
    const nextDial = String(this.props.phone?.countryCode || "").replace(/\D/g, "");
    if (prevDial !== nextDial && nextDial) {
      this.lastDialCode = nextDial;
      const iso = PhoneInputService.dialCodeToIso(nextDial);
      if (iso && iso !== this.state.countryCode) {
        this.setState({ countryCode: iso });
      }
    }
  }

  resolveDialCode(phone, countryIso) {
    const fromPhone = String(phone?.countryCode || "").replace(/\D/g, "");
    if (fromPhone) return fromPhone;
    return PhoneInputService.isoToDialCode(countryIso);
  }

  resolveInitialCountryIso(phone) {
    const dialCode = String(phone?.countryCode || "").replace(/\D/g, "");
    if (dialCode) {
      const fromDial = PhoneInputService.dialCodeToIso(dialCode);
      if (fromDial) return fromDial;
    }
    return (DEFAULT_COUNTRY_CODE || "us").toLowerCase();
  }

  hasUserInput(phone) {
    if (!phone) return false;
    const line = String(phone.lineNumber || "");
    const intl = String(phone.intlNumber || "").replace(/\D/g, "");
    return Boolean(line) || intl.length > 4;
  }

  maybeDetectCountry = async () => {
    if (this.hasUserInput(this.props.phone)) {
      this.setState({ geoReady: true });
      return;
    }

    const geoCountry = await PhoneInputService.getGeoLocation();
    if (geoCountry && !this.userHasTyped) {
      this.lastDialCode =
        this.lastDialCode || PhoneInputService.isoToDialCode(geoCountry);
      this.setState({ countryCode: geoCountry, geoReady: true });
      return;
    }

    this.setState({ geoReady: true });
  };

  emitChange = (phone) => {
    const handler = this.props.onPhoneChange || this.props.onChange;
    handler?.(phone);
  };

  onPhoneChange = (phoneNum, phoneObject) => {
    let phone = phoneService.handlePhoneChange(phoneNum, phoneObject);

    if (phoneObject?.dialCode) {
      this.lastDialCode = String(phoneObject.dialCode).replace(/\D/g, "");
    }

    if (phoneNum && phoneNum !== phoneObject.dialCode) {
      this.userHasTyped = true;
    }

    if (this.state.countryCode !== phoneObject.countryCode) {
      this.setState({ countryCode: phoneObject.countryCode });
    }

    this.emitChange(phone);
  };

  getPhoneInputValue = (phone) => {
    return phoneService.toPhoneInputValue(phone) || "";
  };

  handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    this.userHasTyped = false;
    this.emitChange(phoneService.emptyPhone());
  };

  render() {
    const { phone, disabled = false, inputClass = "clinician-onboard-input", invalid = false } =
      this.props;
    const { countryCode, geoReady } = this.state;
    const hasValue = !phoneService.isProfilePhoneEmpty(phone);

    if (!geoReady && !this.hasUserInput(phone)) {
      return <div className="clinician-onboard-phone-input-wrap" />;
    }

    return (
      <div className="clinician-onboard-phone-input-wrap">
        <PhoneInput
          country={countryCode}
          onlyCountries={PHONE_ONLY_COUNTRIES}
          preferredCountries={PHONE_PREFERRED_COUNTRIES}
          value={this.getPhoneInputValue(phone)}
          disabled={disabled}
          countryCodeEditable={false}
          enableSearch
          disableSearchIcon
          placeholder=""
          containerClass="clinician-onboard-phone-input"
          dropdownClass="clinician-onboard-phone-input__dropdown"
          onChange={this.onPhoneChange}
          inputClass={`${inputClass}${invalid ? " invalid" : ""}`}
        />
        {hasValue && !disabled && (
          <button
            type="button"
            className="clinician-onboard-phone-input__clear"
            onClick={this.handleClear}
            aria-label="Clear phone number"
          >
            ×
          </button>
        )}
      </div>
    );
  }
}

export default WCPhoneInput;
